import { FlightServiceApiInterface, RouteCarriersApiV2Interface } from '@/types/api-types';
import { getPreferredIdentifier } from '@/utils/helpers/get-preferred-identifier';
import { formatFlightNumber } from '@/utils/strings';

export const getFlightServiceFlightNumber = (
  service: FlightServiceApiInterface,
  carriers: RouteCarriersApiV2Interface,
) => {
  const { carrierId, vehicleNumber } = service;
  const carrier = carriers[carrierId];
  const carrierCode = getPreferredIdentifier(carrier.identifiers)?.value || '';
  return formatFlightNumber(carrierCode, vehicleNumber);
};
